import "./styles.css";
import articles from "./articles.json";
import readXlsxFile from "read-excel-file";

let input = document.getElementById("input");
let date = document.querySelector(".date");
let totalFuel = document.querySelector(".totalFuel");
let mmDiesel = document.querySelector(".mmDiesel");
let mm100 = document.querySelector(".mm100");
let fresh = document.querySelector(".fresh");
let foodDry = document.querySelector(".foodDry");
let bevareges = document.querySelector(".bevareges");
let hotDrinks = document.querySelector(".hotDrinks");
let sandwiches = document.querySelector(".sandwiches");
let sandPcs = document.querySelector(".sandPcs");
let backShopAndOthers = document.querySelector(".backShopAndOthers");
let backShopAndOthersPcs = document.querySelector(".backShopAndOthersOcs");
// let submit = document.getElementById("clear");

let count = 1,
  freshCalc = 0,
  foodDryCalc = 0,
  bevaragesCalc = 0,
  hotDrinksCalc = 0,
  sandwichesCalc = 0,
  backShopAndOthersCalc = 0,
  pieces = 0;

input.addEventListener("change", function () {
  readXlsxFile(input.files[0], { getSheets: true }).then((sheets) => {
    while (count <= Object.keys(sheets).length) {
      readXlsxFile(input.files[0], { sheet: `Sheet${count}` }).then(function (
        result
      ) {
        result.forEach((data) => {
          if (data[8] === "TG КроасанМасло2бр") {
            pieces = data[47];
          }
          if (data[0] === "Горива - Rimos") {
            const td = document.createElement("td");
            td.innerText = data[15].toFixed(2);
            totalFuel.appendChild(td);
          } else if (data[8] === "MaxxMotionDiesel") {
            const td = document.createElement("td");
            td.innerText = data[47].toFixed(2);
            mmDiesel.appendChild(td);
          } else if (data[8] === "MaxxMotion100") {
            const td = document.createElement("td");
            td.innerText = data[47].toFixed(2);
            mm100.appendChild(td);
          } else if (data[0] === "Студени Сандвичи") {
            const td = document.createElement("td");
            td.innerText = data[15];
            sandPcs.appendChild(td);
          } else if (data[0] === "Солени Печива") {
            const td = document.createElement("td");
            td.innerText = ((pieces + data[15]) / 2).toFixed(0);
            backShopAndOthersPcs.appendChild(td);
          }
          for (const property in articles.articles) {
            if (
              data[1] === articles.articles[property].sku &&
              articles.articles[property].group.substring(0, 3) === "910"
            ) {
              freshCalc += data[48];
            } else if (
              data[1] === articles.articles[property].sku &&
              articles.articles[property].group.substring(0, 3) === "915"
            ) {
              foodDryCalc += data[48];
            } else if (
              data[1] === articles.articles[property].sku &&
              articles.articles[property].group.substring(0, 3) === "920"
            ) {
              bevaragesCalc += data[48];
            } else if (
              data[1] === articles.articles[property].sku &&
              articles.articles[property].group.substring(0, 3) === "950"
            ) {
              if (
                articles.articles[property].group.substring(0, 5) === "95011"
              ) {
                hotDrinksCalc += data[48];
              } else if (
                articles.articles[property].group.substring(0, 5) === "95014"
              ) {
                sandwichesCalc += data[48];
              } else if (
                articles.articles[property].group.substring(0, 5) === "95010" ||
                articles.articles[property].group.substring(0, 5) === "95012" ||
                articles.articles[property].group.substring(0, 5) === "95013" ||
                articles.articles[property].group.substring(0, 5) === "95015" ||
                articles.articles[property].group.substring(0, 5) === "95016" ||
                articles.articles[property].group.substring(0, 5) === "95017"
              ) {
                backShopAndOthersCalc += data[48];
              }
            }
          }
        });
        let td = document.createElement("td");
        td.innerText = freshCalc.toFixed(2);
        td.classList.add("numbers");
        fresh.appendChild(td);
        td = document.createElement("td");
        td.innerText = foodDryCalc.toFixed(2);
        td.classList.add("numbers");
        foodDry.appendChild(td);
        td = document.createElement("td");
        td.innerText = bevaragesCalc.toFixed(2);
        td.classList.add("numbers");
        bevareges.appendChild(td);
        td = document.createElement("td");
        td.innerText = hotDrinksCalc.toFixed(2);
        td.classList.add("numbers");
        hotDrinks.appendChild(td);
        td = document.createElement("td");
        td.innerText = sandwichesCalc.toFixed(2);
        td.classList.add("numbers");
        sandwiches.appendChild(td);
        td = document.createElement("td");
        td.innerText = backShopAndOthersCalc.toFixed(2);
        td.classList.add("numbers");
        backShopAndOthers.appendChild(td);
        freshCalc = 0;
        foodDryCalc = 0;
        bevaragesCalc = 0;
        hotDrinksCalc = 0;
        sandwichesCalc = 0;
        backShopAndOthersCalc = 0;
        pieces = 0;
      });
      const th = document.createElement("th");
      th.innerText = count;
      date.appendChild(th);
      count++;
    }
  });
});

// submit.addEventListener("click", function () {
//   let tr = document.querySelectorAll("tr");
//   tr.remove();
// });
